import { PivotGrandTotalsEnum } from '@ztechapps/common.contract'

/** Whether the Grand Total columns show — one total per row. */
export const hasPivotGrandTotalColumns = (value: PivotGrandTotalsEnum): boolean =>
  value === PivotGrandTotalsEnum.On || value === PivotGrandTotalsEnum.Rows

/** Whether the Grand Total row shows — one total per column. */
export const hasPivotGrandTotalRow = (value: PivotGrandTotalsEnum): boolean =>
  value === PivotGrandTotalsEnum.On || value === PivotGrandTotalsEnum.Columns
